<template>
    <div v-if="isHttps" class="twitch-video JARVIS_MatchDetail_View_LiveVideo">
        <iframe
            v-bind:title="i18n.t('Twitch_Live_Stream')"
            v-bind:src="url"
            allowfullscreen="true"
            height="100%"
            width="100%"
        />
    </div>
    <div v-else class="twitch-msg">
        <p>{{ i18n.t('Looking_for_Live_Streaming') }}</p>
        <a
            class="button"
            v-bind:href="url"
            target="_blank"
            rel="noopener"
        >
            {{ i18n.t('Watch_Here') }}
        </a>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { i18n } from '@/libraries/i18n';

    export default defineComponent({
        name: 'TwitchLiveStream',
        props: {
            videoUrl: {
                type: String,
                required: true,
            },
            isAutoplay: {
                type: Boolean,
                default: true,
            },
        },
        setup(props) {
            const parentUrl = window.location.host;
            const isHttps = window.location.protocol === 'https:';

            const url = computed(() => `${props.videoUrl}&parent=${parentUrl}&autoplay=${props.isAutoplay}`);

            return {
                i18n,
                isHttps,
                url,
            };
        },
    });
</script>

<style lang="scss" scoped>
    .twitch-video {
        position: relative;
        height: 0;
        padding-top: 56.25%; /* 9:16 ratio */
    }

    .twitch-video iframe {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

    .twitch-msg {
        display: flex;
        height: 56.25vw;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #eeeeee;
        font-size: 1.5rem;

        .button {
            width: initial;
            margin-top: 1rem;
        }
    }
</style>
